export default __webpack_public_path__ + "static/media/notFound.97515e4f.png";